import React from 'react';
import { staticImage } from '../constants';

const AssistantIcon: React.FC = () => (
  <img src={staticImage('robot.svg')} className="assistant-icon" alt="AI Icon" />
);

export default AssistantIcon;
